import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=9e49ff8e&"
import script from "./IconCard.vue?vue&type=script&lang=js&"
export * from "./IconCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e49ff8e')) {
      api.createRecord('9e49ff8e', component.options)
    } else {
      api.reload('9e49ff8e', component.options)
    }
    module.hot.accept("./IconCard.vue?vue&type=template&id=9e49ff8e&", function () {
      api.rerender('9e49ff8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Components/IconCard.vue"
export default component.exports